enum events {
  SHOW_AGENCY_PLAN_UPGRADE_MODAL = 'show-agency-plan-upgrade-modal',
  AGENCY_PLAN_UPGRADE_SUCCEDED = 'agency-plan-upgrade-succeded',
  SHOW_SUPPORT_DRAWER = 'show-support-drawer',
}

export default events
